import React, {Component} from "react";
import {connect} from "react-redux";
import Label from "../Label/Label";
import Storage from "../../../helpers/Storage";
import {default as _} from "../../../helpers/Translate";
import "./TextInput.scss";

class TextInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            inputValue: this.props.defaultValue ?? "",
            language: this.props.language
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.language !== this.props.language) {
            this.handleChangeLanguage(this.props.language);
        }
        if (prevProps.defaultValue !== this.props.defaultValue) {
            this.#stateSetter("inputValue", this.props.defaultValue ?? "");
        }
    }

    #stateSetter = (key, value, callbackFn = () => {
    }) => {
        this.setState({
            [key]: value
        }, callbackFn);
    }

    handleChangeLanguage = (language) => {
        this.#stateSetter("language", language);
    }

    onChangeHandler = (event) => {
        this.#stateSetter("inputValue", event.target.value, () => {
            this.props.handleChange(event);
        });
    }

    render() {
        const {
            type = "text",
            name = "",
            config = {},
            placeholder = "",
            label = null,
            removeColon = false,
            tabIndex
        } = this.props;
        let translatedPlaceholder = _.init(placeholder, this.state.language);

        return <div className="text-input">
            {label && <Label labelText={label} removeColon={removeColon}/>}
            <input
                className={`text-input__input ${this.state.inputValue ? "text-input__input-enabled" : ""} input-${this.state.language}`}
                type={type} name={name} value={this.state.inputValue} onChange={this.onChangeHandler}
                placeholder={translatedPlaceholder} tabIndex={tabIndex} {...config} />
        </div>;
    }
}

const mapStateToProps = state => {
    const language = state.LangReducer.language;
    return {language};
};

export default connect(mapStateToProps)(TextInput);
